const SEARCH_PANED_DESKTOP_PREFIX = "SearchPanelDesktop";
export const DESKTOP_SEARCH_POPOVER_ID = "desktop-search-popover";

export const SEARCH_PANEL_DESKTOP_CLASSES = {
  toolbarWrapper: `${SEARCH_PANED_DESKTOP_PREFIX}-toolbarWrapper`,
  toolbar: `${SEARCH_PANED_DESKTOP_PREFIX}-toolbar`,
  logoCentered: `${SEARCH_PANED_DESKTOP_PREFIX}-logoCentered`,
  logoLeft: `${SEARCH_PANED_DESKTOP_PREFIX}-logoLeft`,
  iconsWrapper: `${SEARCH_PANED_DESKTOP_PREFIX}-iconsWrapper`,
  searchFieldRight: `${SEARCH_PANED_DESKTOP_PREFIX}-searchFieldRight`,
  searchFieldTriggerWrapper: `${SEARCH_PANED_DESKTOP_PREFIX}-searchFieldTriggerWrapper`,
  searchFieldTrigger: `${SEARCH_PANED_DESKTOP_PREFIX}-searchFieldTrigger`,
  searchFieldCentered: `${SEARCH_PANED_DESKTOP_PREFIX}-searchFieldCentered`,
  closeButton: `${SEARCH_PANED_DESKTOP_PREFIX}-closeButton`,
  drawerContent: `${SEARCH_PANED_DESKTOP_PREFIX}-drawerContent`,
  drawer: `${SEARCH_PANED_DESKTOP_PREFIX}-drawer`,
  nativePopover: `${SEARCH_PANED_DESKTOP_PREFIX}-nativePopover`,
  popoverHeader: `${SEARCH_PANED_DESKTOP_PREFIX}-popoverHeader`,
  popoverToolbarWrapper: `${SEARCH_PANED_DESKTOP_PREFIX}-popoverToolbarWrapper`,
  drawerVisible: `${SEARCH_PANED_DESKTOP_PREFIX}-drawerVisible`,
  modalBackdrop: `${SEARCH_PANED_DESKTOP_PREFIX}-modalBackdrop`,
  accountButton: `${SEARCH_PANED_DESKTOP_PREFIX}-accountButton`,
  shoppingListButton: `${SEARCH_PANED_DESKTOP_PREFIX}-shoppingListButton`,
};
